<template>
  <div class="bg-white border-[1px] border-[#E2E2E2] rounded-[8px] p-[16px] text-[#333333]">
    <div class="flex items-center gap-[8px] mb-[8px]">
      <p class="mb-0 font-[500] text-[16px]">
        {{ title }}</p>
    </div>
    <div :class="`my-[24px] ${isLoading ? 'bg-gray-200 rounded-[8px] h-[40px] animate-pulse' : ''}`">
      <slot
        v-if="!isLoading"
        name="content"
      >
        <p class="text-[34px] font-[600] mb-0">
          {{ textContent }}</p>
      </slot>
    </div>
    <div :class="`${isLoading ? 'bg-gray-200 rounded-[8px] h-[24px] animate-pulse w-[76%]' : ''}`">
      <slot
        v-if="!isLoading"
        name="footer"
      >
        <p class="text-[#626262] mb-0">
          {{ textFooter }}</p>
      </slot>
    </div>
  </div>
</template>

<script>
/**
 * Komponen untuk menampilkan card tagihan
 * @description - Komponen untuk menampilkan card tagihan
 * @returns {Object} - Object of component
 * @example
 * <CardTagihan title="Total Tagihan" textContent="1000000" textFooter="Total Tagihan" />
 */
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    textContent: {
      type: String,
      default: '',
    },
    textFooter: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>

</style>
